module.exports = __webpack_public_path__ + "static/media/rain-maker-mobile.2849030f.png";